export const messagesFr = {
  'topbar.app_name': 'Soumission rampe',
  'topbar.tagline': 'Pour Tous · For All',
  'topbar.lang_fr': 'FR',
  'topbar.lang_en': 'EN',
  'hero.status': 'Outil interne · règles CCQ intégrées',
  'hero.title': 'Configure ta rampe',
  'hero.meta': 'Tout sur une page · PDF + Excel + courriel natif',
  'section.01.title': 'Mesures de base',
  'section.02.title': 'Forme de la rampe',
  'section.03.title': 'Options',
  'section.04.title': 'Récap + 3D',
  'section.05.title': 'Client et envoi',
  'measures.usage.label': 'Usage',
  'measures.usage.res': 'Résidentiel',
  'measures.usage.com': 'Commercial',
  'measures.height.label': 'Hauteur à monter (po)',
  'measures.floor.label': 'Type de plancher',
  'measures.floor.plein': 'Plein',
  'measures.floor.mailles': 'Mailles',
  'measures.floor.com_locked': 'En commercial, plancher PLEIN obligatoire (sécurité).',
  'measures.slope.ok': 'Pente {percent} % — conforme Guide GR + CCQ',
  'measures.slope.warn': 'Pente {percent} % — à surveiller',
  'measures.slope.error': 'Pente trop forte ({percent} %) — il faudra rallonger',
  'shape.form.label': 'Forme',
  'shape.form.straight': 'Droite',
  'shape.form.l90': 'En L (90°)',
  'shape.form.u180': 'En U (180°)',
  'shape.run.label': 'Course totale (po)',
  'shape.arm1.label': 'Bras 1 (po)',
  'shape.arm2.label': 'Bras 2 (po)',
  'shape.landing.label': 'Palier (po)',
  'shape.width.label': 'Largeur (po)',
  'shape.rail.label': 'Garde-corps',
  'shape.rail.aucun': 'Aucun',
  'shape.rail.ajoure': 'Ajouré',
  'shape.rail.barrotin': 'Barrotin',
  'shape.rail.barrotin_mains': 'Barrotin avec mains',
  'shape.rail.warn_height': 'Hauteur > 24" — garde-corps obligatoire (CCQ chute > 600 mm)',
  'shape.rail.accept': 'Accepter {type}',
  'options.mode.label': 'Mode',
  'options.mode.achat': 'Achat',
  'options.mode.location': 'Location',
  'options.rental.duration': 'Durée location (mois)',
  'options.install.label': 'Installation + transport',
  'options.install.km': 'Distance aller (km)',
  'options.uninstall.label': 'Désinstallation (aller-retour transport)',
  'recap.preview3d': 'Aperçu 3D · drag pour rotation',
  'recap.subtotal': 'Sous-total',
  'recap.tps': 'TPS (5 %)',
  'recap.tvq': 'TVQ (9,975 %)',
  'recap.grand_total': 'GRAND TOTAL',
  'recap.rental.monthly': 'Mensualité ({months} mois)',
  'recap.rental.total': 'Total location',
  'recap.rental.buyback': 'Rachat 20 %',
  'recap.alerts.title': 'À surveiller',
  'recap.errors.title': 'À corriger',
  'recap.info.title': 'À noter',
  'client.subtitle': '{usage} · {height} po de hauteur',
  'client.usage.res': 'Résidentiel',
  'client.usage.com': 'Commercial',
  'client.name.label': 'Nom du client',
  'client.name.placeholder': 'ex : Marie Tremblay',
  'client.address.label': 'Adresse du chantier',
  'client.address.placeholder': 'ex : 456 av. des Pins, Montréal',
  'client.email.label': 'Courriel client (pour envoi)',
  'client.email.placeholder': 'ex : marie.tremblay@email.ca',
  'client.photo.label': 'Photo du chantier (optionnel)',
  'client.photo.placeholder': 'Prendre / choisir une photo',
  'client.photo.added': 'Photo ajoutée',
  'cta.send_email': 'Envoyer par courriel',
  'cta.send_email.busy': 'Préparation…',
  'cta.download_pdf': 'Télécharger PDF',
  'cta.download_pdf.busy': 'Génération…',
  'cta.download_excel': 'Télécharger Excel',
  'cta.download_excel.busy': 'Génération…',
  'toast.pdf_done': 'PDF téléchargé',
  'toast.excel_done': 'Excel téléchargé',
  'toast.email_shared': 'Soumission partagée',
  'toast.email_mailto': 'Courriel ouvert (sans pièces jointes)',
  'toast.email_cancelled': 'Partage annulé',
  'toast.no_quote': 'Aucun devis à exporter',
  'toast.error_pdf': 'Erreur génération PDF',
  'toast.error_excel': 'Erreur génération Excel',
  'toast.error_email': 'Erreur lors du partage',
  'footer.copyright': 'Confidentiel · ©2026',
  'app.loading_catalog': 'Chargement catalogue…',
  'app.catalog_error.title': 'Erreur de chargement',
  'app.catalog_error.body': 'Impossible de charger le catalogue produits.',
  'app.catalog_error.reload': 'Recharger',
  'email.body.greeting': 'Bonjour {name},',
  'email.body.intro': 'Voici votre soumission.',
  'email.body.signoff': 'Au plaisir,',
  'shape.l90.turn.label': 'Sens du virage',
  'shape.l90.turn.left': 'Gauche',
  'shape.l90.turn.right': 'Droite',
  'shape.l90.landing.label': 'Palier de virage',
  'shape.l90.landing.5x5': '5×5 (60×60") — standard',
  'shape.l90.landing.5x8': '5×8 (60×96") — haut',
  'shape.head_platform.label': 'Plateforme tête',
  'shape.head_platform.5x5': '5×5 (60×60") — standard',
  'shape.head_platform.5x8': '5×8 (60×96") — haut',
  'chart.title': "Charte d'inclinaisons officielle",
  'chart.subtitle': 'Référence Go Rampe · dénivelé × longueur → angle',
  'chart.close': 'Fermer',
  'chart.legend': 'Légende :',
  'chart.current': 'Votre config : {height}″ × {length}′ → {angle}°',
  'chart.height_label': 'Dénivelé (po) ↓',
  'chart.footer': 'Source : Go Rampe Inc. · 1-888-957-2673 · contact@gorampe.com',
  'measures.slope.view_chart': 'Voir la charte',
  'bom.qty': 'Quantité',
  'bom.cut_from_stock': 'coupé du stock',
  'bom.material': 'Matériau',
  'bom.tree.aria': 'Liste BOM',
  'bom.title': 'Nomenclature (BOM)',
  'bom.empty': 'Configurez la rampe pour voir la nomenclature.',
  'recap.3d_panel.aria': 'Visualisation 3D de la rampe configurée',
} as const;

export type MessageKey = keyof typeof messagesFr;
